<div #track class="min-w-0 overflow-hidden text-right">
  <!-- One text run rather than a flex row: `text-overflow` only applies to the block holding the
       text, and an inline-block keeps reporting its natural width for the fit test above. -->
  <span
    #content
    class="inline-block whitespace-nowrap text-xs text-gray-500"
    [class.opacity-0]="!fits"
    [matTooltip]="fullPath"
  >
    <ng-container *ngFor="let node of path; let last = last"
      >{{ node.name
      }}<span *ngIf="!last" aria-hidden="true">&nbsp;&rsaquo;&nbsp;</span></ng-container
    >
  </span>
</div>
